<app-header></app-header>

<!-- Hero Banner -->
<div class="section display-flex-center hero-section" style="height: 230px; margin-bottom: 50px; margin-top: 86px;">
  <div class="background-image"
    style="background-image: url('./assets/image/corporate-hero.jpg')">
  </div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <h1 class="text-center">Corporate &amp; Business Sales Inquiry</h1>
      </div>
    </div>
  </div>
</div>

<!-- Inquiry Form -->
<div class="section" style="padding-bottom: 60px;">
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-8 mx-auto">

        <form [formGroup]="corporateForm" (ngSubmit)="onSubmit()">

          <!-- Row 1 -->
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="companyName">1. Company Name <span style="color: red;">*</span></label>
                <input type="text" class="form-control input-lg" id="companyName"
                  placeholder="Enter your company name"
                  formControlName="companyName">
                <div class="text-danger small mt-1" *ngIf="isInvalid('companyName')">
                  {{ getError('companyName') }}
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="contactName">2. Name <span style="color: red;">*</span></label>
                <input type="text" class="form-control input-lg" id="contactName"
                  placeholder="Enter your full name"
                  formControlName="contactName">
                <div class="text-danger small mt-1" *ngIf="isInvalid('contactName')">
                  {{ getError('contactName') }}
                </div>
              </div>
            </div>
          </div>

          <!-- Row 2 -->
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="contactNumber">3. Contact <span style="color: red;">*</span></label>
                <input type="tel" class="form-control input-lg" id="contactNumber"
                  placeholder="e.g. 012-345 6789"
                  formControlName="contactNumber">
                <div class="text-danger small mt-1" *ngIf="isInvalid('contactNumber')">
                  {{ getError('contactNumber') }}
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="email">4. Email <span style="color: red;">*</span></label>
                <input type="email" class="form-control input-lg" id="email"
                  placeholder="Enter your business email"
                  formControlName="email">
                <div class="text-danger small mt-1" *ngIf="isInvalid('email')">
                  {{ getError('email') }}
                </div>
              </div>
            </div>
          </div>

          <!-- Row 3 -->
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="officeLocation">5. Office Location <span style="color: red;">*</span></label>
                <input type="text" class="form-control input-lg" id="officeLocation"
                  placeholder="Enter your office address"
                  formControlName="officeLocation">
                <div class="text-danger small mt-1" *ngIf="isInvalid('officeLocation')">
                  {{ getError('officeLocation') }}
                </div>
              </div>
            </div>
          </div>

          <!-- Row 4: Type of Service Required -->
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="service-section-label">6. Type of Service Required <span style="color: red;">*</span></label>
                <div class="service-checkboxes no-box" [class.border-danger]="!hasAnyService() && corporateForm.touched">

                  <div class="checkbox-row">
                    <label class="service-checkbox-label">
                      <input type="checkbox" formControlName="nextDayDelivery">
                      Next-day delivery guarantee
                    </label>
                    <label class="service-checkbox-label">
                      <input type="checkbox" formControlName="perishableDelivery">
                      Perishable item delivery
                    </label>
                  </div>

                  <div class="checkbox-row">
                    <label class="service-checkbox-label">
                      <input type="checkbox" formControlName="expressDelivery">
                      Express delivery (1-3 working days)
                    </label>
                    <label class="service-checkbox-label">
                      <input type="checkbox" formControlName="warehousing">
                      Warehousing
                    </label>
                  </div>

                  <div class="checkbox-row single">
                    <label class="service-checkbox-label">
                      <input type="checkbox" formControlName="cartonDelivery">
                      Carton delivery
                    </label>
                  </div>

                </div>
                <div class="text-danger small mt-1" *ngIf="!hasAnyService() && corporateForm.touched">
                  Please select at least one type of service.
                </div>
              </div>
            </div>
          </div>

          <!-- Submit -->
          <div class="row" style="margin-top: 25px;">
            <div class="col-md-12 text-center">
              <button type="submit" class="btn btn-lg track-btn"
                [disabled]="isSubmitting"
                style="background-color: #40BFEF; color: #fff; border: none; padding: 12px 50px; font-size: 16px;">
                <i class="fa fa-paper-plane"></i>
                {{ isSubmitting ? 'Sending...' : 'Submit Inquiry' }}
              </button>
              <button type="button" class="btn btn-lg btn-default"
                (click)="resetForm()"
                style="padding: 12px 30px; font-size: 16px; margin-left: 10px;">
                Clear
              </button>
            </div>
          </div>

        </form>

      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
